import { useCallback, useContext, useMemo } from 'react';
import { DisplayNamesRegion, Locale } from '@medable/i18n-core-v4';
import { LocaleContext } from './i18n_context';
/**
 * Returns narrow, localized display names for region codes.
 *
 * Pseudo-locales use a code-preserving placeholder because `DisplayNamesRegion`
 * does not pseudo-localize region names itself.
 */
export const useRegionDisplayName = () => {
    const locale = useContext(LocaleContext);
    const localeInstance = useMemo(() => new Locale(locale), [locale]);
    const displayNames = useMemo(() => new DisplayNamesRegion(localeInstance, { style: 'narrow' }), [localeInstance]);
    return useCallback((region) => {
        const regionCode = region === null || region === void 0 ? void 0 : region.trim().toUpperCase();
        if (!regionCode) {
            return '';
        }
        if (localeInstance.isPseudoLocale) {
            return `[[[Region:${regionCode}]]]`;
        }
        return displayNames.of(regionCode);
    }, [displayNames, localeInstance]);
};
//# sourceMappingURL=use_region_display_name.js.map